export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./iron-partner-modal.vue?vue&type=template&id=24771cf4&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/iron-partner-modal.vue?vue&type=template&id=24771cf4&
// module id = 1743
// module chunks = 0